import classnames from 'classnames';
import React, { useEffect, useState } from 'react';
import { Button, Col, Nav, NavItem, NavLink, Row, TabContent, TabPane, Alert } from 'reactstrap';
import { getFees, getPaymentTypes, processPayment } from '../../API';
import PaymentInfo from './PaymentInfo';
import ReviewAndSubmitPayment from './ReviewAndSubmitPayment';
import PublicPaymentSuccessModal from './PublicPaymentSuccessModal';
import PaymentFailureModal from './PaymentFailureModal';
import LoadingSVG from '../../icons/Spinner-1s-200px.svg';

function PayFees(props) {
    const [activeTab, setActiveTab] = useState('paymentInfo');
    const [paymentTypes, setPaymentTypes] = useState([]);
    const [fees, setFees] = useState([]);
    const [feePayments, setFeePayments] = useState([]);
    const [paymentInfo, setPaymentInfo] = useState({ sslTransactionType: 'na', sslExpMonth: '01', sslBankAccountType: 1, sslState: 'SD' });
    const [makingPayment, setMakingPayment] = useState(false);
    const [paymentSuccessModal, setPaymentSuccessModal] = useState(false);
    const [paymentFailureModal, setPaymentFailureModal] = useState(false);
    const [paymentFailureMessage, setPaymentFailureMessage] = useState('');

    useEffect(() => {
        fetchPaymentTypes();
    }, []);

    useEffect(() => {
        fetchFees();
    }, [props.linkedAccounts]);

    useEffect(() => {
        setFeePayments(fees.map(f => { return { feeID: f.feeID, paymentAmount: f.currentBalance } }));
    }, [fees]);

    const fetchPaymentTypes = async () => {
        setPaymentTypes(await getPaymentTypes());
    };

    const fetchFees = async () => {
        if (props.linkedAccounts.length > 0) {
            const fetchedFees = await getFees({ accountIds: props.linkedAccounts.map(so => so.accountID), paid: 0 });
            //fetchedFees.forEach(f => f.paymentAmount = f.currentBalance);
            setFees(fetchedFees);
        } else {
            setFees([]);
        }
    };

    const toggle = tab => {
        if (activeTab !== tab) setActiveTab(tab);
    };

    const togglePaymentSuccessModal = () => setPaymentSuccessModal(!paymentSuccessModal);
    const togglePaymentFailureModal = () => setPaymentFailureModal(!paymentFailureModal);

    const paymentInfoOptions = {
        transactionTypes: ['ccsale', 'ecspurchase']
    };

    const reviewAndSubmitOptions = {

    };

    const updatePaymentInfo = (e) => {
        setPaymentInfo({ ...paymentInfo, [e.target.name]: e.target.value });
    }

    const totalPaymentAmount = props.linkedAccounts.map(so => so.currentFeeBalance).reduce((a, b) => a + b, 0);

    const makePaymentTransaction = async () => {
        setMakingPayment(true);

        const firstFee = fees !== null && fees.length > 0 ? fees[0] : null;
        const feeDescriptions = fees.map(f => f.account.accountNumber + ' ' + f.fiscalYear + ' ' + f.division.divisionName + ' ' + f.identifier);
        const feeDescription = feeDescriptions.join('; ');
        const paymentData = {
            feePayments: feePayments.filter(fp => fp.paymentAmount > 0),
            paymentInfo: {
                ...paymentInfo,
                sslEmail: window.env.user?.emailAddress,
                sslCardExpDate: paymentInfo.sslExpMonth + paymentInfo.sslExpYear?.slice(-2),
                sslAmount: totalPaymentAmount,
                customFields: [
                    {
                        name: 'ssl_invoice_number',
                        value: firstFee !== null ? firstFee.account?.accountNumber.substring(0, 25) : ''
                    },
                    {
                        name: 'ssl_description',
                        value: feeDescription.substring(0, 255)
                    }
                ]
            }
        };

        try {
            const response = await processPayment(paymentData);
            console.log(response);
            if (response.ssl_result_message === 'APPROVAL') {
                console.log('SUCCESS!!!');
                setPaymentSuccessModal(true);
            } else {
                console.log('FAILURE!!! ' + response.ssl_result_message);
                setPaymentFailureMessage(response.ssl_result_message);
                setPaymentFailureModal(true);
            }
        } catch (ex) {
            console.log(ex);
            setPaymentFailureMessage('Error: ' + (ex.message || 'An error occured with the payment.'));
            setPaymentFailureModal(true);
        }

        setMakingPayment(false);
    };

    return (
        <div id="payFees">
            <Row className="header-row">
                <Col>
                    <h1>Pay Fees</h1>
                </Col>
            </Row>
            <Row className="tabs-row">
                <Col>
                    <Nav tabs>
                        <NavItem>
                            <NavLink
                                className={classnames({ active: activeTab === 'paymentInfo' })}
                                onClick={() => { toggle('paymentInfo'); }}>
                                Payment Info
                            </NavLink>
                        </NavItem>
                        <NavItem>
                            <NavLink
                                className={classnames({ active: activeTab === 'reviewSubmit' })}
                                onClick={() => { toggle('reviewSubmit'); }}>
                                Review and Submit
                            </NavLink>
                        </NavItem>
                    </Nav>
                </Col>
            </Row>
            <Row className="tab-content-row">
                <Col>
                    <TabContent activeTab={activeTab}>
                        <TabPane tabId="paymentInfo">
                            <PaymentInfo options={paymentInfoOptions} paymentInfo={paymentInfo} updatePaymentInfo={updatePaymentInfo} />
                            <div className="tab-nav-button">
                                <div></div>
                                <Button color="danr-green" onClick={() => { toggle('reviewSubmit'); }}><span>Next</span></Button>
                            </div>
                        </TabPane>
                        <TabPane tabId="reviewSubmit">
                            <ReviewAndSubmitPayment options={reviewAndSubmitOptions} paymentInfo={paymentInfo} fees={fees} feePayments={feePayments} />
                            <div className="tab-nav-button">
                                <Button color="danr-red" onClick={() => { toggle('paymentInfo'); }}><span>Back</span></Button>
                                <Button color="danr-green" onClick={makePaymentTransaction} disabled={makingPayment}><span>Submit</span></Button>
                            </div>
                            {makingPayment ?
                                <div className="loading"><img src={LoadingSVG} alt="Loading..." /></div>
                                : null}
                        </TabPane>
                    </TabContent>
                </Col>
            </Row>
            <PublicPaymentSuccessModal open={paymentSuccessModal} toggle={togglePaymentSuccessModal} />
            <PaymentFailureModal open={paymentFailureModal} toggle={togglePaymentFailureModal} message={paymentFailureMessage || 'An error occured with the payment.'} />
        </div>
    );
}

export default PayFees;